import React, { useEffect } from 'react'
import cl from './CollectingScores.module.css'
import { Flex, Table, Tbody, Thead, Tr, Th, Td, Link, Text, Grid } from '@chakra-ui/react'
import { useScoreStore } from '../../store/scoreStore'
import SelectCommunicationType from '../../components/SelectCommunicationType/SelectCommunicationType'
import CollectingScoresTag from './CollectingScoresTag'
import CollectingScoresInputPoints from './CollectingScoresInputScore'
import CollectingScoresComment from './CollectingScoresComment'
import CollectingScoresIsContacted from './CollectingScoresIsContacted'
import CollectingScoresConfirmations from './CollectingScoresConfirmations'
import CollectingScoresScans from './CollectingScoresScans'
import UmSpinner from '../../components/UI/UmSpinner'
import CollectingScoresParentPhone from './CollectingScoresParentPhone'
import { CheckIcon, NotAllowedIcon } from '@chakra-ui/icons'
import RoleTag from '../../components/UI/RoleTag'
import { usePagination } from '../../hooks/usePagination'
import Pagination from '../../components/Pagination/Pagination'
import CollectingScoresIsVerifedOKK from './CollectingScoresIsVerifedOKK'

const PAGINATION_LIMIT = 30

function CollectingScoresTable() {
    const filteredData = useScoreStore(state => state.filteredData)
    const isFiltering = useScoreStore(state => state.isFiltering)
    const paginatedData = useScoreStore(state => state.paginatedData)
    const setPaginatedData = useScoreStore(state => state.setPaginatedData)
    const pagination = usePagination()

    useEffect(() => {
        pagination.setPage(1)
        pagination.setMaxPage(Math.ceil(filteredData.length / PAGINATION_LIMIT))
        setPaginatedData(filteredData.slice((pagination.page - 1) * PAGINATION_LIMIT, pagination.page * PAGINATION_LIMIT))
    }, [filteredData])

    useEffect(() => {
        setPaginatedData(filteredData.slice((pagination.page - 1) * PAGINATION_LIMIT, pagination.page * PAGINATION_LIMIT))
    }, [pagination.page])

    const getLastStatusDate = (data, collectingPoint) => {
        if (collectingPoint?.last_tag_date && data.is_contacted_created_at)
            return new Date(Math.max(
                new Date(collectingPoint.last_tag_date),
                new Date(data.is_contacted_created_at)
            )).toLocaleDateString()
        
        if (collectingPoint?.tag?.created_at || collectingPoint?.last_tag_date)
            return new Date(collectingPoint?.tag?.created_at || collectingPoint?.last_tag_date).toLocaleDateString()

        return '-'
    }

    if (isFiltering)
        return <UmSpinner />

    return (
        <Grid>
            <div className={cl.tableWrapper}>
                <Table>
                    <Thead position="sticky" top={0} zIndex="sticky">
                        <Tr>
                            <Th>Имя ученика</Th>
                            <Th>ID на платформе</Th>
                            <Th>Почта</Th>
                            <Th>Номер телефона ученика</Th>
                            <Th>Номер телефона родителя</Th>
                            <Th>Тип предпочтительной связи</Th>
                            <Th>Продолжительность обучения</Th>
                            <Th>Когорта</Th>
                            <Th>Предмет</Th>
                            <Th>Класс</Th>
                            <Th>Есть Предбанник Про?</Th>
                            <Th>Успеваемость ученика</Th>
                            <Th>Отписан?</Th>
                            <Th>Тег</Th>
                            <Th>Дата последнего статуса</Th>
                            <Th>Результат</Th>
                            <Th>Подтверждение</Th>
                            <Th>Скан работ</Th>
                            <Th>Комментарий</Th>
                            <Th>Проверено ОКК</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {paginatedData.map(data => (
                            <Tr key={data.id}>
                                <Td>
                                    <Link href={data?.link_on_dialog} isExternal>
                                        {`${data?.last_name} ${data?.first_name}`}
                                    </Link>
                                </Td>
                                <Td>
                                    <Link href={`https://old.umschool.net/predbannik/core/user/${data?.site_id}`} isExternal>
                                        {data?.site_id}
                                    </Link>
                                </Td>
                                <Td>{data?.email || '-'}</Td>
                                <Td>{data?.phone || '-'}</Td>
                                <Td>
                                    <CollectingScoresParentPhone scoreData={data} />
                                </Td>
                                <Td>
                                    <SelectCommunicationType student={data} />
                                </Td>
                                <Td>{data?.count_months && data.count_months ? `${data.count_months} мес` : '-'}</Td>
                                <Td>
                                    {data?.cohort || '-'}
                                </Td>
                                <Td>
                                    <Flex className={cl.tdMultipleRow}>
                                        {data?.collecting_points && data.collecting_points.map(p => (
                                            <Text key={p.id}>{p?.subject_title || '-'}</Text>
                                        ))}
                                    </Flex>
                                </Td>
                                <Td>
                                    <Flex className={cl.tdMultipleRow}>
                                        {data?.collecting_points && data.collecting_points.map(p => (
                                            <Text key={p.id}>{data.class_year_id === 3 ? '11 класс' : '9 класс'}</Text>
                                        ))}
                                    </Flex>
                                </Td>
                                <Td>
                                    <Flex justify='center' align='center'>
                                        {
                                            data?.has_pb_pro && data.has_pb_pro !== 0
                                            ?
                                            <CheckIcon boxSize={5} color='green' />
                                            :
                                            <NotAllowedIcon boxSize={5} color='red' />
                                        }
                                    </Flex>
                                </Td>
                                <Td>
                                    <Flex justify='center' align='center'>
                                        <RoleTag
                                            role={{ title: data.color }}
                                            colorScheme={data.color}
                                        />
                                    </Flex>
                                </Td>
                                <Td>
                                    <CollectingScoresIsContacted scoreData={data} />
                                </Td>
                                <Td>
                                    <Flex className={cl.tdMultipleRow} gap='6px'>
                                        {data?.collecting_points && data.collecting_points.map(p => (
                                            <CollectingScoresTag
                                                siteId={data.site_id}
                                                pointData={p}
                                                key={p.id}
                                            />
                                        ))}
                                    </Flex>
                                </Td>
                                <Td>
                                    <Flex className={cl.tdMultipleRow}>
                                        {data?.collecting_points && data.collecting_points.map(p => (
                                            <Text key={p.id}>
                                                {getLastStatusDate(data, p)}
                                            </Text>
                                        ))}
                                    </Flex>
                                </Td>
                                <Td>
                                    <Flex className={cl.tdMultipleRow}>
                                        {data?.collecting_points && data.collecting_points.map(p => (
                                            <CollectingScoresInputPoints
                                                scoreData={data}
                                                pointData={p}
                                                key={p.id}
                                            />
                                        ))}
                                    </Flex>
                                </Td>
                                <Td>
                                    <CollectingScoresConfirmations data={data} />
                                </Td>
                                <Td>
                                    <CollectingScoresScans data={data} />
                                </Td>
                                <Td>
                                    <Flex className={cl.tdMultipleRow}>
                                        {data?.collecting_points && data.collecting_points.map(p => (
                                            <CollectingScoresComment
                                                scoreData={data}
                                                pointData={p}
                                                key={p.id}
                                            />
                                        ))}
                                    </Flex>
                                </Td>
                                <Td bg='green.50'>
                                    <CollectingScoresIsVerifedOKK scoreData={data} />
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </div>
            <Pagination pagination={pagination} disabled={!filteredData || filteredData.length < 1} />
        </Grid>
    )
}

export default CollectingScoresTable
